import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import { pinia } from "@/stores/pinia";
import { useSystemStore } from "@/stores/system";
import { useAuthStore } from "@/stores/auth";
import { useHttpStore } from "@/stores/http";
// import VueGtag from "vue-gtag";

// VIEWS
import AboutRisePartner from "@/views/AboutRisePartner.vue";
import AboutRiseDistributor from "@/views/AboutRiseDistributor.vue";
import BonusDashboardPartner from "@/views/BonusDashboardPartner.vue";
import BonusDashboardDistributor from "@/views/BonusDashboardDistributor.vue";
import ContactUs from "@/views/ContactUs.vue";
import EligibleProducts from "@/views/EligibleProducts.vue";
import Login from "../views/LoginView.vue";
import HomeView from "@/views/HomeView.vue";
import HomePartner from "@/views/HomePartner.vue";
import HomeDistributor from "@/views/HomeDistributor.vue";

import RedirectAPJ from "@/components/RedirectAPJ.vue";
import MyPerformance from "@/views/MyPerformance.vue";

import RewardsCalculator from "@/views/RewardsCalculator.vue";
import RewardsCalculatorDisti from "@/views/RewardsCalculatorDisti.vue";
import Registration from "@/views/Registration.vue";
import UserProfile from "@/views/UserProfile.vue";
import Redemption from "@/views/Redemption.vue";
import RedemptionSummary from "@/views/RedemptionSummary.vue";
import DistributorEVoucherReport from "@/views/DistributorEVoucherReport.vue";
import PartnerEVoucherReport from "@/views/PartnerEVoucherReport.vue"
import ForgotPassword from "@/views/ForgotPassword.vue";
import Legals from "@/views/RiseLegals.vue";
import MarketingAssets from "@/views/MarketingAssets.vue";
import RISEOpportunities from "@/views/RISEOpportunities.vue";
import FAQView from "@/views/FAQView.vue";
import MessagesView from "@/views/MessagesView.vue";
import NewsView from "@/views/NewsView.vue";
import DistributorDashboard from "@/views/DistributorDashboard.vue";
import PartnerPerformance from "@/views/PartnerPerformance.vue";
import DistributorRedemptionReport from "@/views/DistributorRedemptionReport.vue";
import DistributorRedemptionBankedReport from "@/views/DistributorRedemptionBankedReport.vue";
import DistributorReferralReport from "@/views/DistributorReferralReport.vue";
import CreditNoteReport from "@/views/CreditNoteReport.vue";
import DnCP from '@/views/DnCP.vue';
import AdminView from "@/views/AdminView.vue";
import AdminImpersonateUser from "@/views/AdminImpersonateUser.vue";
import DellInternalReports from "@/views/DellInternalReports.vue";
import GoogleAnalytics from "@/views/GoogleAnalytics.vue";
import RewardsPaid from "@/views/RewardsPaid.vue"

//COMPONENTS
import PortalTermsAndConditions from "../components/PortalTermsAndConditions.vue";
import RISETermsAndConditions from "../components/RISETermsAndConditions.vue";
import PrivacyStatement from "../components/PrivacyStatement.vue";
import CookiesInformation from "@/components/CookiesInformation.vue";

import TestUpload from '@/components/FileUpload.vue'
// createWebHashHistory(),

//Auth Service
import authService from '@/services/auth';
import Callback from "@/components/Callback.vue";
import LogoutCallback from "@/components/LogoutCallback.vue";

const router = createRouter({
  history: createWebHashHistory(), // createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/apj",
      name: "apj",
      component: RedirectAPJ,
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {title: 'Login'},
    },
    {
      path: "/home",
      name: "home",
      component: HomeView,
      beforeEnter: checkAuth,
      meta: {},
      children: [
        // {
        //   path: "/test",
        //   name: "test",
        //   component: TestUpload,
        // },
        {
          name: "home-partner",
          path: "partner",
          component: HomePartner,
          beforeEnter: checkAuth,
          meta: {
            title: 'Partner Home',
            authorisedRoles: ['Partner', 'Dell', 'TIC_Admin']
          },
        },
        {
          name: "home-distributor",
          path: "distributor",
          component: HomeDistributor,
          beforeEnter: checkAuth,
          meta: {title: 'Distributor Home'},
        },
        {
          name: "home-eligible-products",
          path: "eligible-products",
          component: EligibleProducts,
          beforeEnter: checkAuth,
          meta: {title: 'Eligible Products'},
        },
        {
          name: "home-about-rise-partner",
          path: "about-rise-partner",
          component: AboutRisePartner,
          beforeEnter: checkAuth,
          meta: {title: 'About RISE - Partner'},
        },
        {
          name: "home-about-rise-distributor",
          path: "about-rise-distributor",
          component: AboutRiseDistributor,
          beforeEnter: checkAuth,
          meta: {title: 'About RISE - Distributor'},
        },
        {
          name: "my-performance",
          path: "my-performance",
          component: MyPerformance,
          beforeEnter: checkAuth,
          meta: {title: 'My Performance'},
        },
        {
          name: "bonus-dashboard-partner",
          path: "bonus-dashboard-partner",
          component: BonusDashboardPartner,
          beforeEnter: checkAuth,
          meta: {title: 'Bonus Dashboard - Partner'},
        },
        {
          name: "bonus-dashboard-distributor",
          path: "bonus-dashboard-distributor",
          component: BonusDashboardDistributor,
          beforeEnter: checkAuth,
          meta: {title: 'Bonus Dashboard - Distributor'},
        },
        {
          name: "rewards-calculator",
          path: "rewards-calculator",
          component: RewardsCalculator,
          beforeEnter: checkAuth,
          meta: {title: 'Rewards Calculator'},
        },
        {
          name: "rewards-calculator-disti",
          path: "rewards-calculator-disti",
          component: RewardsCalculatorDisti,
          beforeEnter: checkAuth,
          meta: {title: 'Rewards Calculator - Distributor'},
        },
        {
          name: "user-profile",
          path: "user-profile",
          component: UserProfile,
          beforeEnter: checkAuth,
          meta: {title: 'User Profile'},
        },
        {
          name: "redemption",
          path: "redemption",
          component: Redemption,
          beforeEnter: checkAuth,
          meta: {title: 'Redeem Rewards'},
        },
        {
          name: "redemption-summary",
          path: "redemption-summary",
          component: RedemptionSummary,
          beforeEnter: checkAuth,
          meta: {title: 'Redemption Summary'},
        },
        {
          name: "distributor-evoucher-report",
          path: "distributor-evoucher-report",
          component: DistributorEVoucherReport,
          beforeEnter: checkAuth,
          meta: {title: 'E-Voucher Report'},
        },
        {
          path: "cookies-information",
          name: "cookies-information",
          component: CookiesInformation,
          beforeEnter: checkAuth,
          meta: {title: 'Cookies Information'},
        },
        {
          path: "privacy-statement",
          name: "privacy-statement",
          component: PrivacyStatement,
          beforeEnter: checkAuth,
          meta: {title: 'Privacy Statement'},
        },
        {
          path: "terms-of-use",
          name: "terms-of-use",
          component: PortalTermsAndConditions,
          beforeEnter: checkAuth,
          meta: {title: 'Terms of Use'},
        },
        {
          path: "marketing-assets",
          name: "marketing-assets",
          component: MarketingAssets,
          beforeEnter: checkAuth,
          meta: {title: 'Marketing Assets'},
        },
        {
          path: "rise-opportunities",
          name: "rise-opportunities",
          component: RISEOpportunities,
          beforeEnter: checkAuth,
          meta: {title: 'RISE Opportunities'},
        },
        { path: "bonus-opportunities", redirect: { name: "rise-opportunities" } },
        {
          path: "contact-us",
          name: "contact-us",
          component: ContactUs,
          beforeEnter: checkAuth,
          meta: {title: 'Contact Us'},
        },
        {
          path: "faq",
          name: "faq",
          component: FAQView,
          beforeEnter: checkAuth,
          meta: {title: 'FAQ'},
        },
        {
          path: "messages",
          name: "messages",
          component: MessagesView,
          beforeEnter: checkAuth,
          meta: {title: 'Messages'},
        },
        {
          path: "news",
          name: "news",
          component: NewsView,
          beforeEnter: checkAuth,
          meta: {title: 'News & Promotions'},
        },
        {
          path: "distributor-dashboard",
          name: "distributor-dashboard",
          component: DistributorDashboard,
          beforeEnter: checkAuth,
          meta: {title: 'Distributor Dashboard'},
        },
        {
          path: "partner-performance",
          name: "partner-performance",
          component: PartnerPerformance,
          beforeEnter: checkAuth,
          meta: {title: 'Partner Performance'},
        },
        {
          path: "distributor-redemption",
          name: "distributor-redemption",
          component: DistributorRedemptionReport,
          beforeEnter: checkAuth,
          meta: {title: 'Distributor Redemption Report'},
        },
        {
          path: "distributor-redemption-banked",
          name: "distributor-redemption-banked",
          component: DistributorRedemptionBankedReport,
          beforeEnter: checkAuth,
          meta: {title: 'Redemption Balance Report (incl. Banked Rewards)'},
        },
        {
          path: "distributor-referral-report",
          name: "distributor-referral-report",
          component: DistributorReferralReport,
          beforeEnter: checkAuth,
          meta: {title: 'Distributor Referral Report'},
        },
        {
          path: "creditnote-report",
          name: "creditnote-report",
          component: CreditNoteReport,
          beforeEnter: checkAuth,
          meta: {title: 'Credit Note Report'},
        },
        {
          path: "dell-internal-reports",
          name: "dell-internal-reports",
          component: DellInternalReports,
          beforeEnter: checkAuth,
          meta: {title: 'Dell Internal Reports'},
        },
        {
          path: "dncp",
          name: "dncp",
          component: DnCP,
          beforeEnter: checkAuth,
          meta: {title: 'DnCP'},
        },
        {
          path: "partner-rewards-paid",
          name: "partner-rewards-paid",
          component: RewardsPaid,
          beforeEnter: checkAuth,
          meta: {title: 'Rewards Paid'}
        }
      ],
    },
    {
      name: "registration",
      path: "/registration",
      component: Registration,
      meta: {title: 'Registration'},
    },
    {
      name: "forgot-password",
      path: "/forgot-password",
      component: ForgotPassword,
      meta: {title: 'Forgot Password'},
    },
    {
      path: "/info",
      name: "info",
      component: Legals,
      children: [
        {
          path: "cookies-information",
          name: "noauth-cookies-information",
          component: CookiesInformation,
          meta: {title: 'Cookies Information'},
        },
        {
          path: "privacy-statement",
          name: "noauth-privacy-statement",
          component: PrivacyStatement,
          meta: {title: 'Privacy Statement'},
        },
        {
          path: "terms-of-use",
          name: "noauth-terms-of-use",
          component: PortalTermsAndConditions,
          meta: {title: 'Terms of Use'},
        },
        {
          path: "eligible-products",
          name: "noauth-eligible-products",
          component: EligibleProducts,
          meta: {title: 'Eligible Products'},
        },
        {
          path: "rewards-calculator",
          name: "noauth-rewards-calculator",
          component: RewardsCalculator,
          meta: {title: 'Rewards Calculator'},
        },
      ],
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminView,
      beforeEnter: checkAuth,
      meta: {title: 'Admin Portal'},
    },
    {
      path: "/google-analytics",
      name: "google-analytics",
      component: GoogleAnalytics,
      beforeEnter: checkAuth,
      meta: {title: 'Google Analytics'},
    },
    {
      path: "/impersonateUser/:id",
      name: "impersonateUser",
      component: AdminImpersonateUser,
      meta: {},
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback,
    },
    {
      path: "/logout-callback",
      name: "logout-callback",
      component: LogoutCallback,
    },
  ],
});

function checkAuth(to, from, next) {
  const systemStore = useSystemStore(pinia);
  const authStore = useAuthStore(pinia);
  const httpStore = useHttpStore(pinia);

  // Allow Okta callback routes without auth check
  if (to.path === '/callback' || to.path === '/logout-callback') {
    next();
    return;
  }

  systemStore.requestedRoute = to.name

  httpStore.token = sessionStorage.getItem("accessToken");

  if (httpStore.token != null && httpStore.token.trim().length > 0) {
    var ast = systemStore.getData("assets");

    systemStore
      .getUserDetails()
      .then((res) => {
        // the acess token is still valid
        if (res.success === true) {
          ast.tv = 1;
          systemStore.setData('assets', ast);

          // first check if otp was entered correctly
          if (ast.ua === 1 && ast.tv === 1 && ast.otp === 1) {
            systemStore.userDetail = res.userDetail;

            if (to.name === "admin") {
              if (systemStore.userDetail.userType.trim() === 'TIC_Admin' && systemStore.userDetail.affinityId === 987654321) { }
              else {
                return false;
              }
            }

            if (systemStore.userDetail.userType.trim() === 'Distributor') {
              if (to.name === "home-about-rise-partner") {
                next({ name: 'home-about-rise-distributor' })
              }
              else {
                next();
              }
            }
            else if (systemStore.userDetail.userType.trim() === 'Partner') {
              if (to.name === "home-about-rise-distributor") {
                next({ name: 'home-about-rise-partner' })
              }
              else {
                next();
              }
            }
            else {
              next();
            }

          } else {
            systemStore.showMessage('Unable to route to destination, please login.', { color: 'error' })
            next("/");
          }
        } else {
          httpStore.token = "";
          next("/");
        }
      })
      .catch((error) => {
        httpStore.token = "";
        next("/");
      });
  } else {
    next("/");
  }
};


// afterEach
router.beforeEach((to, from, next) => {

  const toDepth = to.path.split("/").length;
  const fromDepth = from.path.split("/").length;
  to.meta.transition = toDepth < fromDepth ? "slide-right" : "slide-left";
  document.title = to.meta.title || "RISE Portal";

  // next()

  // this is to add a manual delay between page transitions
  setTimeout(() => {
    next();
  }, 100);
});

// router.afterEach((to, from, next) => {
//   VueGtag('set', 'page', router.currentRoute.path);
//   VueGtag('send', 'pageview');

// router.afterEach(( to, from ) => {
//   VueGtag('set', 'page', to.path);
//   VueGtag('send', 'pageview');
// });

// });


export default router;
